import React, { useState } from 'react';

import {
  ArrowUpRight,
  Car,
  ForkKnife,
  HandSoap,
  // ShoppingCartSimple,
  Truck,
} from '@phosphor-icons/react';
import { useLocation, useNavigate } from 'react-router-dom';
import AutomobilesIllustration from 'src/assets/automobiles-case-illustration.svg';
import FoodIllustration from 'src/assets/food-case-illustration.svg';
import HygieneIllustration from 'src/assets/hygiene-case-illustration.svg';
import LogisticsIllustration from 'src/assets/logistics-case-illustration.svg';
// import RetailIllustration from 'src/assets/retail-case-illustration.svg';
import { Button } from 'src/components/Button';
import { TrackGoogleAnalyticsEvent } from 'src/utils/google-analytics';

import { CasesTab, Container, Content, Tabs } from './styles';

export function Cases() {
  const [selectedCase, setSelectedCase] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const allCases = [
    {
      icon: <ForkKnife weight="duotone" />,
      name: 'Alimentos',
      url: '/cases/food',
      title: 'Prevendo aumento nos custos e otimizando o pricing',
      description: (
        <p>
          Veja como multinacional de alimentos utilizou a 4intelligence para
          fazer análises de sensibilidade e alcançou um{' '}
          <b>aumento de 26% na receita da companhia</b>.
        </p>
      ),
      img: FoodIllustration,
    },
    {
      icon: <Car weight="duotone" />,
      name: 'Automóveis',
      url: '/cases/automobiles',
      title: 'Projeção de vendas para otimizar a produção de caminhões',
      description: (
        <p>
          Veja como a multinacional de automóveis utilizou a 4intelligence para
          prever como seriam suas vendas e alcançou um{' '}
          <b>aumento de 45,7% na vendas de caminhões</b>.
        </p>
      ),
      img: AutomobilesIllustration,
    },
    {
      icon: <HandSoap weight="duotone" />,
      name: 'Higiene e Beleza',
      url: '/cases/hygiene-beauty',
      title: 'Projeção de mercado para otimizar o processo de S&OP',
      description: (
        <p>
          Veja como multinacional de higiene e beleza{' '}
          <b>
            desburocratizou o planejamento e análise de vendas e operações, S&OP
          </b>
          , com uma plataforma mais ágil, assertiva e precisa.
        </p>
      ),
      img: HygieneIllustration,
    },
    {
      icon: <Truck weight="duotone" />,
      name: 'Logística',
      url: '/cases/logistics',
      title: 'Projeção de produção, exportação, consumo e estoque',
      description: (
        <p>
          Veja como empresa de logística resolveu a necessidade de aprimoramento
          das projeções de produção, exportação, consumo e estoque e alcançou um{' '}
          <b>aumento de 10% no total de cargas transportadas</b>.
        </p>
      ),
      img: LogisticsIllustration,
    },
    // {
    //   icon: <ShoppingCartSimple weight="duotone" />,
    //   name: 'Varejo',
    //   url: '/cases/retail',
    //   title: 'Expansão de rede de lojas de vestuário pelo Brasil',
    //   description: (
    //     <p>
    //       Veja como a empresa têxtil e de varejo de vestuário brasileira
    //       utilizou a 4intelligence e conseguiu{' '}
    //       <b>expandir sua rede de lojas pelo Brasil</b>.
    //     </p>
    //   ),
    //   img: RetailIllustration,
    // },
  ];

  return (
    <Container>
      <Tabs>
        {allCases.map((item, index) => (
          <CasesTab
            key={item.name}
            selected={selectedCase === index}
            onClick={() => {
              TrackGoogleAnalyticsEvent(
                item.name,
                `Visualizar aba do case ${item.name}`,
                location.pathname,
              );
              setSelectedCase(index);
            }}
            data-testid={`case-tab-${item.name
              .toLowerCase()
              .replaceAll(' ', '-')}`}
          >
            {item.icon}
            <p>{item.name}</p>
          </CasesTab>
        ))}
      </Tabs>
      <Content>
        <div>
          <h3>{allCases[selectedCase].name}</h3>
          <h1>{allCases[selectedCase].title}</h1>
          {allCases[selectedCase].description}

          <Button
            buttonType="naked"
            icon={<ArrowUpRight />}
            iconInvert
            onClick={() => {
              TrackGoogleAnalyticsEvent(
                `Saiba mais - ${allCases[selectedCase].name}`,
                `Ir para o case ${allCases[selectedCase].name}`,
                location.pathname,
              );
              navigate(allCases[selectedCase].url);
            }}
            data-testid="know-more-case-button"
          >
            Saiba mais
          </Button>
        </div>
        <div>
          <img
            src={allCases[selectedCase].img}
            alt="case illustration representation"
          />
        </div>
      </Content>
    </Container>
  );
}
